<div class="grid" [ngClass]="(isMobile$ | async) ? undefined : 'grid-cols-[1.25fr_1fr]'">
  <div class="grid h-screen items-center">
    <div
      @fadeInUpAnimation
      class="max-w-2xl lg:p-24"
      [ngClass]="(isMobile$ | async) ? 'justify-self-center p-4' : 'justify-self-end p-12'">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div *ngIf="!(isMobile$ | async)" class="hidden md:block">
    <sbnb-review-carousel></sbnb-review-carousel>
  </div>
</div>
